var _ = require('underscore');
var validate_domain = require('./validate_domain.js');

var React = require("react");
const createReactClass = require("create-react-class");

var ActionButtons = require('./ActionButtons.jsx');
var RadioButton = require('./RadioButton.jsx');
var DomainInfo = require('./DomainInfo.jsx');
var Row = require('./Row.jsx');

var ServerNames = createReactClass({

	getNewState: function() {
		return {
			dns: "",
			www: true,
			ssl: false,
			primary: false
		};
	},

	getInitialState: function() {
		return {
			SecurityID: this.props.model.InitialSecurityID,
			Original: JSON.parse(JSON.stringify(this.props.model.Domains)),
			WorkingCopy: JSON.parse(JSON.stringify(this.props.model.Domains)),
			NewDomain: this.getNewState(),
			DomainsNeedFullDeploy: this.props.model.DomainsNeedFullDeploy,
			DomainInfo: this.props.model.DomainInfo,
			messageSecondary: {type: 'success', body: ''},
			inEditMode: false,
			isSaving: false,
			changed: false,
			failed_validation: false
		};
	},

	updateState: function(data) {
		this.setState({
			SecurityID: data.NewSecurityID,
			Original: JSON.parse(JSON.stringify(data.Domains)),
			WorkingCopy: JSON.parse(JSON.stringify(data.Domains)),
			NewDomain: this.getNewState(),
			DomainsNeedFullDeploy: data.DomainsNeedFullDeploy,
			inEditMode: false,
			changed: false,
			isSaving: false,
			failed_validation: false
		});
	},

	notificationMessage: function() {
		if(!this.state.DomainsNeedFullDeploy) {
			return null;
		}
		return (
			<div
				className="alert alert-warning"
				dangerouslySetInnerHTML={{__html:this.props.model.FullDeployNeededMessage}}
			/>
		);
	},

	formMessage: function() {
		if(!this.state.messageSecondary.body) {
			return null;
		}
		return (
			<div className="variables">
				<div className={'alert alert-'+this.state.messageSecondary.type}
					dangerouslySetInnerHTML={{__html:this.state.messageSecondary.body}}/>
			</div>
		);
	},

	changeHandler: function(changeData) {

		// keep a copy of the current workingCopy state so we don't accidentally
		// change state outside of a setState() call. Using the
		// JSON.parse(JSON.stringify()) is a way of cloning the object that
		// works, but could have performance impacts if done in a hotspot,
		// but this function isn't a hotspot.
		var stateClone = JSON.parse(JSON.stringify(this.state.WorkingCopy));

		switch(changeData.action) {
			case 'change':
				if(typeof stateClone[changeData.id] === "undefined") {
					console.warn("Trying to change non existing domain with id '" + changeData.id + "'");
					return;
				}

				stateClone[changeData.id][changeData.type] = changeData.value;
				this.setState({
					WorkingCopy: stateClone,
					changed: JSON.stringify(this.state.Original) !== JSON.stringify(stateClone),
					failed_validation : !!(changeData.error) // cast to boolean
				});
				break;

			// save changes to the 'new' row
			case 'add':
				var tmpNew = this.state.NewDomain;
				tmpNew[changeData.type] = changeData.value;
				this.setState({
					NewDomain: tmpNew
				});
				break;

			case 'add_row':
				// move every row down a step so that we can insert the new item
				// first into the list
				stateClone = this.moveDown(stateClone, 0);
				stateClone[0] = this.state.NewDomain;
				this.setState({
					NewDomain: this.getNewState(),
					WorkingCopy: stateClone,
					changed: JSON.stringify(this.state.Original) !== JSON.stringify(stateClone)
				}, function() {
					this.refs.new.focus();
				});
				break;

			case 'delete':
				if(typeof stateClone[changeData.id] === "undefined") {
					console.warn("Trying to delete non existing domain with id '" + changeData.id + "'");
					return;
				}
				// effectively deletes the object key
				stateClone = _.omit(stateClone, changeData.id);
				this.setState({
					WorkingCopy: stateClone,
					changed: JSON.stringify(this.state.Original) !== JSON.stringify(stateClone)
				});
				break;

			case 'primary':
				if(typeof stateClone[changeData.id] === "undefined") {
					console.warn("Trying to set primary domain on a non existing domain with id '" + changeData.id + "'");
					return;
				}
				_.map(stateClone, function(domain, id) {
					if(typeof stateClone[id] === 'undefined') {
						return;
					}
					stateClone[id].primary = (id === changeData.id);
				});
				this.setState({
					WorkingCopy: stateClone,
					changed: JSON.stringify(this.state.Original) !== JSON.stringify(stateClone)
				});
				break;
		}
	},

	moveDown: function(object, id) {
		if(typeof object[id + 1] !== "undefined") {
			this.moveDown(object, id + 1)
		}
		object[id + 1] = object[id];
		delete(object[id]);
		return object;
	},

	editHandler: function() {
		this.setState({
			inEditMode: !this.state.inEditMode
		})
	},

	saveHandler: function() {
		this.setState({
			isSaving: true
		});
		var parent = this;
		return Q($.ajax({
			type: "POST",
			url: this.props.model.DomainsAction,
			data: {
				Details: JSON.stringify(this.state.WorkingCopy),
				DispatcherSecurityID: this.state.SecurityID
			}
		})).then(function(data) {
			parent.updateState(data);
			parent.setState({
				messageSecondary: {type: 'success', body: data.Message},
				isSaving: false
			});
		}).fail(function(data) {
			parent.setState({
				messageSecondary: {type: 'danger', body: "Failed to save changes: " + data.responseText},
				isSaving: false
			});
		});

	},

	cancelHandler: function() {
		this.setState({
			changed: false,
			inEditMode: false,
			NewDomain: this.getNewState(),
			WorkingCopy: JSON.parse(JSON.stringify(this.props.model.Domains))
		});
	},

	render: function() {
		var addNewRow = null;
		if(this.state.inEditMode) {
			addNewRow = (
				<Row
					ref="new"
					domain={this.state.NewDomain}
					inEditMode={this.state.inEditMode}
					changeHandler={this.changeHandler}
					newState={this.getNewState()}
				/>
			);
		}

		var secondaryDomains = _.map(this.state.WorkingCopy, function(domain, id) {
			if(typeof domain === 'undefined') {
				return;
			}
			return (
				<Row
					key={id}
					id={id}
					domain={domain}
					inEditMode={this.state.inEditMode}
					changeHandler={this.changeHandler}
				/>
			);
		}.bind(this));

		var domainList = _.map(this.state.WorkingCopy, function(domain, id) {
			if(typeof domain === 'undefined' || domain.dns == "") {
				return;
			}
			return <RadioButton
				key={id}
				id={id}
				type="primary"
				value={domain.primary}
				ssl={domain.ssl}
				www={domain.www}
				dns={domain.dns}
				disabled={!this.state.inEditMode}
				onChange={this.changeHandler}
			/>;
		}.bind(this));

		let primaryDomainSelection = null;
		if (this.props.model.SupportsPrimaryDomainSelection) {
			primaryDomainSelection = (
				<div className="primary-domain-selection">
					<h4>Primary domain</h4>

					<p className="domains-description">Select the domain to be used to link to the site in command line scripts, such as cron jobs.</p>
					<div className="domain-list">
						{domainList}
					</div>
				</div>
			)
		}

		return (
			<div className="domains">
				<h3>Domains and redirections</h3>

				<p className="domains-description">Configure domains your environment will respond to. These settings need to be configured at your domain provider:</p>
				<DomainInfo data={this.state.DomainInfo} />
				<p>Please see <a href="https://servicedesk.silverstripe.cloud/support/solutions/articles/75000012856-domains">Domains documentation</a> for more information.</p>

				<div className="clearfix">
					{this.notificationMessage()}
					<ActionButtons
						inEditMode={this.state.inEditMode}
						isSaving={this.state.isSaving}
						onEdit={this.editHandler}
						onSave={this.saveHandler}
						onCancel={this.cancelHandler}
						isDisabled={this.state.failed_validation || this.state.isSaving || !this.state.changed}
					/>
				</div>

				{this.formMessage()}

				<table className="table table-fullwidth">
					<thead>
						<tr>
							<th className="prefix">Redirect to</th>
							<th>Domain name</th>
							<th className="text-center">
								www
								<a
									className="icon-link"
									role="button"
									data-toggle="popover"
									title="www redirection"
									data-placement="top"
									data-content="Listen on the www domain, and redirect non-www to www. This is recommended."
								> <i className="fa fa-question-circle"></i></a>
							</th>
							<th className="text-center">
								https
								<a
									className="icon-link"
									role="button"
									data-toggle="popover"
									title="HTTPS redirection"
									data-placement="top"
									data-content="Redirect HTTP to HTTPS. Please ensure the certificate is configured first."
								> <i className="fa fa-question-circle"></i></a>
							</th>
							<th className="actions"></th>
						</tr>
					</thead>
					<tbody>
						{addNewRow}
						{secondaryDomains}
					</tbody>
				</table>

				{primaryDomainSelection}
			</div>
		);
	}
});

module.exports = ServerNames;
